export type CampaignStatus = "brief" | "execution" | "completed" | "all";

export const getStatusColorClass = (
  status: string,
  styles: Record<string, string>
): string => {
  if (status === "Campaign") {
    return styles.statusExecution;
  } else if (status === "Closed") {
    return styles.statusCompleted;
  } else if (status === "Brief") {
    return styles.statusBrief;
  }
  return styles.statusDefault;
};

export const getStatusMainStatusFilter = (filter: CampaignStatus): string[] => {
  if (filter === "all") {
    return [];
  } else if (filter === "brief") {
    return ["Brief"];
  } else if (filter === "execution") {
    return ["Campaign"];
  } else if (filter === "completed") {
    return [];
  }
  return [];
};
